import { gql } from './generated/gql';

// eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
export default gql(/** @complexity 12 */ `
  mutation updateTopic(
    $id: ID!
    $banner: Upload
    $unsplashId: String
    $name: String
    $description: Json
    $parentId: ID
    $privacy: TopicPrivacy
    $memberEditable: TopicMemberEditable
    $detached: TopicDetached
    $defaultSort: TopicPostsOrder
    $defaultShow: TopicPostsType
    $propagatePrivacy: Boolean
  ) {
    updateTopic(
      id: $id
      banner: $banner
      unsplashId: $unsplashId
      name: $name
      description: $description
      parentId: $parentId
      privacy: $privacy
      memberEditable: $memberEditable
      detached: $detached
      defaultSort: $defaultSort
      defaultShow: $defaultShow
      propagatePrivacy: $propagatePrivacy
    ) {
      ...TopicFields
      banner {
        original
      }
      ancestors {
        ...TopicFields
      }
      children {
        ...TopicFields
      }
    }
  }
`);
